import React from "react";
import Gullak from "@assets/svg/Wallet/Gullak";
import Earning from "@assets/svg/Wallet/Earning";
import Refund from "@assets/svg/Wallet/Refund";
import WithDrawal from "@assets/svg/Wallet/Withdrawal";
import Tds from "@assets/svg/Wallet/Tds";
import DeliveryFee from "@assets/svg/Wallet/DeliveryFee";
import IncentiveFee from "@assets/svg/Wallet/IncentiveFee";
import Penalty from "@assets/svg/Wallet/Penalty";
import FakeCxRto from "@assets/svg/Wallet/FakeCxRto";
import DamagePenalty from "@assets/svg/Wallet/DamagePenalty";
import RtoPenalty from "@assets/svg/Wallet/RtoPenalty";
import PickupMissing from "@assets/svg/Wallet/PickupMissing";
import { WalletTxnType } from "../utils";

const getWalletIcon = (key: string): React.ReactNode => {
  switch (key) {
    case WalletTxnType.ALL:
      return <Gullak />;
    case WalletTxnType.EARNING:
      return <Earning />;
    case WalletTxnType.REFUND:
      return <Refund />;
    case WalletTxnType.WITHDRAWAL:
      return <WithDrawal />;
    case WalletTxnType.TDS:
      return <Tds />;
    case WalletTxnType.DELIVERY_FEE:
      return <DeliveryFee />;
    case WalletTxnType.INCENTIVE_FEE:
      return <IncentiveFee />;
    case WalletTxnType.PENALTY:
      return <Penalty />;
    case WalletTxnType.FAKE_RTO:
      return <FakeCxRto />;
    case WalletTxnType.HIGH_DAMAGE:
      return <DamagePenalty />;
    case WalletTxnType.HIGH_RTO:
      return <RtoPenalty />;
    case WalletTxnType.RVP_PICKUP_MISSING:
      return <PickupMissing />;
    case WalletTxnType.CRATE_PENALTY:
      return <Penalty />;
    default:
      return <Gullak />;
  }
};

export default getWalletIcon;
